/**
 * 创建唯一的字符串
 * @return {string} ojgdvbvaua40
 */
function createUniqueString () {
    const timestamp = +new Date() + '';
    const randomNum = parseInt((1 + Math.random()) * 65536) + '';
    return (+(randomNum + timestamp)).toString(32);
}

/**
 * 数字存储大小格式化
 * @param {number} num 存储大小 单位：Byte
 * @param {number} digits 保留几位小数
 * @return {string} 2MB
 */
function toStorage (num, digits) {
    digits = digits || 2;
    if (num < 1024) {
        return num + 'B';
    }
    num = (num * 1000 / 1024);
    const si = [
        { value: 1E18, symbol: 'E' },
        { value: 1E15, symbol: 'P' },
        { value: 1E12, symbol: 'T' },
        { value: 1E9, symbol: 'G' },
        { value: 1E6, symbol: 'M' },
        { value: 1E3, symbol: 'K' }
    ];
    for (let i = 0; i < si.length; i++) {
        if (num >= si[i].value) {
            return (num / si[i].value).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') +
                si[i].symbol + 'B';
        }
    }
}

/**
 * 日期格式化为 "01-Nov-2025" 格式
 * @param {string|Date} date 日期
 * @return {string} 格式化后的日期字符串
 */
function formatDate(date) {
    if (!date) return '';
    const moment = require('moment');
    return moment(date).format('DD-MMM-YYYY');
}

export default {
    createUniqueString,
    toStorage,
    formatDate
};